import { UserCheck } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@tendbot/ui'

interface Props {
  open: boolean
  fromEmail: string
  onClose: () => void
  onConfirm: () => void
}

export default function TriageClaimConfirmModal({ open, fromEmail, onClose, onConfirm }: Props) {
  const { t } = useTranslation('chat')

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose() }}>
      <DialogContent accent="gold">
        <div className="flex justify-center mb-4">
          <div className="w-14 h-14 rounded-full bg-gold/10 border border-gold/20 grid place-items-center">
            <UserCheck size={26} className="text-gold" />
          </div>
        </div>
        <DialogHeader>
          <DialogTitle>{t('triage.claimModal.title')}</DialogTitle>
          <DialogDescription>
            {t('triage.claimModal.description', { email: fromEmail })}
          </DialogDescription>
        </DialogHeader>
        <p className="text-xs text-pearl/70 text-center mt-2">{t('triage.claimModal.detail')}</p>
        <DialogFooter className="mt-6 gap-3">
          <button
            onClick={onClose}
            className="flex-1 py-3 rounded-xl bg-slate-mid/50 border border-slate-mid text-pearl font-medium text-sm hover:bg-slate-mid/80 transition-colors"
          >
            {t('triage.claimModal.cancel')}
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 py-3 rounded-xl bg-gold text-midnight font-semibold text-sm hover:bg-gold-light transition-colors flex items-center justify-center gap-2"
          >
            <UserCheck size={16} />
            {t('triage.claimModal.confirm')}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
